import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { formatMinRedeemUsd } from '../lib/rewards-config'
import { RiGiftLine } from '@/shared/icons/remix'
import { REWARDS_REDEEM_DISABLED_TOOLTIP } from '../lib/rewards-copy'
import {
  rewardsGiftCardSx,
  rewardsGiftDescriptionSx,
  rewardsGiftMinSx,
  rewardsGiftPillSx,
  rewardsGiftPillTextSx,
  rewardsRedeemButtonSx,
} from '../styles/rewardsPageStyles'

interface Props {
  readonly redeemEnabled: boolean
  readonly onRedeem: () => void
}

export function RewardsGiftCard({ redeemEnabled, onRedeem }: Readonly<Props>) {
  const redeemButton = (
    <Button
      variant="contained"
      disabled={!redeemEnabled}
      onClick={onRedeem}
      data-testid="rewards-redeem-button"
      sx={rewardsRedeemButtonSx}
    >
      Redeem
    </Button>
  )

  return (
    <Box sx={rewardsGiftCardSx} data-testid="rewards-gift-card-cta">
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
        <Box sx={rewardsGiftPillSx}>
          <RiGiftLine size={17} color="#0E8A5F" aria-hidden />
          <Typography component="span" sx={rewardsGiftPillTextSx}>
            Gift Card
          </Typography>
        </Box>
        <Typography sx={rewardsGiftMinSx}>
          {`${formatMinRedeemUsd()} minimum`}
        </Typography>
      </Box>

      <Typography sx={rewardsGiftDescriptionSx}>
        Redeem at stores like Amazon, Target, Starbucks and more
      </Typography>

      {redeemEnabled ? (
        redeemButton
      ) : (
        <Tooltip title={REWARDS_REDEEM_DISABLED_TOOLTIP} arrow>
          <Box component="span" sx={{ display: 'inline-flex', alignSelf: 'flex-start' }}>
            {redeemButton}
          </Box>
        </Tooltip>
      )}
    </Box>
  )
}
